// extracted by css-extract-rspack-plugin
export default {"layout":"aP2jr","panel":"nkay1","scrollable":"Zzhql","targetRow":"nQ6Wn","footer":"U7Mms"};